<template>
    <v-container>
      <v-row 
      dense
      v-if="$user.availableCoupons.length > 0"
      >
        <v-col
          v-for="(item, i) in $user.availableCoupons"
          :key="i"
          cols="12"
        >
          <v-card
            :color="item.color"
            light
          >
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title
                  class="text-h5"
                  v-text="item.title"
                ></v-card-title>

                <v-card-subtitle v-text="item.amount"></v-card-subtitle>
                <v-card-text>
                  <v-rating
                  length="5"
                  size="20"
                  half-increments
                  :value="item.rating"
                  >
                  </v-rating>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    class="ml-2 mt-5"
                    rounded
                  >
                    USE DISCOUNT
                  </v-btn>
                  <v-btn
                    class="ml-2 mt-5"
                    outlined
                    rounded
                    small
                  >
                    <v-icon>mdi-map-marker</v-icon> Location
                  </v-btn>
                </v-card-actions>
              </div>

              <v-avatar
                class="ma-3 ml-n8 float-right"
                size="125"
                rounded
              >
                <v-img :src="item.src"></v-img>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row
      v-else>
        <v-col
        cols="12"
        v-if="loading"
        class="d-flex justify-center">
          <v-progress-circular
            indeterminate
            color="green"
          ></v-progress-circular>
        </v-col>
        <v-col
          cols="12"
          v-else
          class=" text-center"
        >
          <h1>No rewards available...</h1>
          <h4>(Try refreshing!)</h4>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import EventBus from '../bus';
export default {
  name:'Coupons',
  data() {
    return {
      loading:false,
      count:0,
    };
  },
  mounted(){
    EventBus.$on('fab-action',this.FABAction);
  },
  methods:{
    FABAction(){
      this.count++;
      if(this.count > 1) return;
      this.loading=true;
      setTimeout(() => {
        this.loading=false;
        this.$user.availableCoupons = [{
          id:0,
          color:"white",
          title:"Test coupon!",
          amount: "$15",
          src: require('../assets/discount-pictures/0.jpg'),
          rating:4.5,
        }];
        this.count = 0;
        console.log(this.$user.availableCoupons);
      },2000)
    }
  }
}
</script>

<style>

</style>